import React, { useEffect, useState } from "react";
import { getCommentNumber, getLikeNumber } from "../api";
import { isSameUser } from "../lib/utils";

const SaveInfo = ({ post, user }) => {
  const [like, setLike] = useState(0);
  const [comment_numb, setComment_numb] = useState(0);

  const isLiked = isSameUser(post?.liker_id, user?.id);
  const isSaved = isSameUser(post?.saver_id, user?.id);

  const comment_count = () => {
    if (!post?.id) return;

    getCommentNumber(post.id)
      .then((res) => setComment_numb(res.data["count"]))
      .catch((error) => console.error("Comment count error:", error));
  };

  const likeCount = () => {
    if (!post?.id) return;

    getLikeNumber(post.id)
      .then((res) => setLike(res.data["count"]))
      .catch((error) => console.error("Like count error:", error));
  };

  useEffect(() => {
    if (!post?.id) return;

    likeCount();
    comment_count();

    const interval = setInterval(() => {
      likeCount();
      comment_count();
    }, 2000);

    return () => clearInterval(interval);
  }, [post?.id, post?.liker_id]);

  return (
    <div className="flex w-full items-center justify-between gap-3">
      {/* LIKE */}

      <button type="button" className="flex min-w-0 items-center gap-1 text-sm">
        <img src={isLiked ? "/assets/icons/liked.svg" : "/assets/icons/like.svg"} alt={isLiked ? "liked" : "like"} />
        <span className="whitespace-nowrap text-center">{like > 0 ? like : ""} <span className="hidden xs:inline">pinok</span></span>
      </button>

      {/* COMMENTS */}

      <button type="button" className="flex min-w-0 items-center gap-1 text-sm">
        <img src="/assets/icons/chat.svg" alt="comments" />
        <span className="whitespace-nowrap">{comment_numb > 0 ? comment_numb : ""} <span className="hidden xs:inline">{comment_numb === 1 ? "comment" : "comments"}</span></span>
      </button>

      {/* SAVE */}

      <button type="button" className="flex min-w-0 items-center gap-1 text-sm">
        <img src={isSaved ? "/assets/icons/saved.svg" : "/assets/icons/save.svg"} alt={isSaved ? "saved" : "save"} />
        <span className="hidden whitespace-nowrap xs:inline">{isSaved ? "saved" : "save"}</span>
      </button>
    </div>
  );
};

export default SaveInfo;